import { Component } from 'solid-js'

interface FlagIconProps {
  class?: string
  size?: number
  filled?: boolean
}

const FlagIcon: Component<FlagIconProps> = (props) => {
  const size = props.size || 16
  const filled = props.filled ?? true

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      class={props.class}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15.1137098,5.988224 L20,5.988224 L20,17 L15.1158601,17 C13.845863,17 12.6247196,16.5266107 11.6882941,15.6776239 L11.5048751,15.5028475 C10.5476326,14.5443068 9.24855376,14.005695 7.89389016,14.005695 L4,14.005695 L4,3 L7.89604047,3 C9.16488579,3 10.385055,3.47233588 11.3214495,4.31967333 L11.5048751,4.494112 C12.4622224,5.45081073 13.7602748,5.988224 15.1137098,5.988224 Z" />
        <line x1="4" y1="3" x2="4" y2="20.9731713" />
      </g>
    </svg>
  )
}

export default FlagIcon
